import React, { FC, PropsWithChildren } from 'react';

import { CustomBrRenderer } from './CustomBrRenderer';
import {
  CustomTableBodyComponent,
  CustomTableComponent,
  CustomTableDataCellComponent,
  CustomTableHeadComponent,
  CustomTableHeaderCellComponent,
  CustomTableRowComponent,
} from './CustomTableComponents';

export const CustomTableRenderer: FC<PropsWithChildren> = ({ children }) => {
  // Filter out any <br> tags that GetStream injects
  const filteredChildren = React.Children.toArray(children).filter((child) => {
    if (
      React.isValidElement(child) &&
      (child.type === 'br' || child.type === CustomBrRenderer)
    ) {
      return false;
    }
    return true;
  });

  return <CustomTableComponent>{filteredChildren}</CustomTableComponent>;
};

export const CustomTheadRenderer: FC<PropsWithChildren> = ({ children }) => (
  <CustomTableHeadComponent>{children}</CustomTableHeadComponent>
);

export const CustomTbodyRenderer: FC<PropsWithChildren> = ({ children }) => {
  // Filter out <br> tags that GetStream injects
  const filteredChildren = React.Children.toArray(children).filter((child) => {
    if (
      React.isValidElement(child) &&
      (child.type === 'br' || child.type === CustomBrRenderer)
    ) {
      return false;
    }
    return true;
  });

  return (
    <CustomTableBodyComponent>{filteredChildren}</CustomTableBodyComponent>
  );
};

export const CustomTrRenderer: FC<PropsWithChildren> = ({ children }) => {
  // Check if this row contains only empty cells or separator content
  const isEmpty = React.Children.toArray(children).every((child) => {
    if (
      !React.isValidElement<PropsWithChildren>(child) ||
      !child.props.children
    ) {
      return true;
    }
    const content = child.props.children;
    if (typeof content === 'string') {
      // Check if it's just dashes, spaces, or colons (separator row content)
      return !content.trim() || /^[-:\s]*$/.test(content.trim());
    }
    return false;
  });

  if (isEmpty) {
    return null;
  }

  return <CustomTableRowComponent>{children}</CustomTableRowComponent>;
};

export const CustomThRenderer: FC<PropsWithChildren> = ({ children }) => (
  <CustomTableHeaderCellComponent>{children}</CustomTableHeaderCellComponent>
);

export const CustomTdRenderer: FC<PropsWithChildren> = ({ children }) => (
  <CustomTableDataCellComponent>{children}</CustomTableDataCellComponent>
);
